// External libraries
import gql from 'graphql-tag';

// 3DS 1.0 (mostly IN) contingency fragment
export const THREE_DOMAIN_SECURE_FRAGMENT = gql`
  fragment threeDomainSecure on PaymentContingencies {
    threeDomainSecure(experiences: $supportedThreeDsExperiences) {
      status
      redirectUrl {
        href
      }
      method
      parameter
      experience
      requestParams {
        key
        value
      }
    }
  }
`;
